import request from '@/server/request'
import { API_JAVA } from '@/utils/base'

// 轮播
export async function apiGetSlideShow(params) {
  return request(API_JAVA + '/backstage/advertisingSpace/list',{
    method: 'GET',
    params: params
  })
}

// 现货推荐
export async function apiGetSpotRecommendation (params) {
  return request(API_JAVA + '/jgw/jgwProduct/mall/recommend', {
    method: 'GET',
    params: params
  })
}

// 根据三级品类查询一级品类
export async function GetOneLevelCategoryList (params) {
  return request(`${API_JAVA}/purchase/category/first/list`, {
    method: 'POST',
    data: params
  })
}

// 供求信息
export async function apiGetSupplyDemand (params) {
  return request(`${API_JAVA}/tmr/supplyAndDemand/list`, {
    method: 'GET',
    params: params
  })
}

// 内容管理
export async function apiGetContentInformaton (params) {
  return request(API_JAVA + '/tmr/contentManage/list', {
    method: 'GET',
    params: params
  })
}

// 经纪人
export async function apiGetJobber(params) {
  return request( API_JAVA+'/tmr/broker/list',{
    method: 'GET',
    params: params
  })
}


// 成交动态
export async function apiGetDynamic(params) {
  return request( API_JAVA+'/tmr/index/orderTrends',{
    method: 'GET',
    params: params
  })
}

// 订单明细
export async function apiGetOrderDetail(params) {
  return request( API_JAVA+'/jgw/jgwOrder/' + params.id,{
    method: 'GET',
    params: params
  })
}

// 新增地址
export async function apiAddAddress(params) {
  return request( API_JAVA+'/jgw/MemberReceiveAddress/add',{
    method: 'POST',
    data: params
  })
}
// 编辑地址
export async function apiEditAddress(params) {
  return request( API_JAVA+'/jgw/MemberReceiveAddress/update',{
    method: 'POST',
    data: params
  })
}

// 删除地址
export async function apiDelAddress(params) {
  return request( API_JAVA+'/jgw/MemberReceiveAddress/delete/' + params.id,{
    method: 'POST',
    data: params
  })
}

// 收货地址列表
export async function apiGetAddressList(params) {
  return request( API_JAVA+'/jgw/MemberReceiveAddress/list',{
    method: 'GET',
    params: params
  })
}

// 商品管理列表
export async function apiGetCommodityManagement(params) {
  return request( API_JAVA+'/jgw/jgwProduct/list',{
    method: 'GET',
    params: params
  })
}

// 下架商品
export async function apiDelCommodityManagement(params) {
  return request( API_JAVA+'/jgw/jgwProduct/updateProductStatus/' + params.id,{
    method: 'POST',
    data: params
  })
}

// 下架商品
export async function apiAddTheme(params) {
  return request( API_JAVA+'/jgw/feedback/add',{
    method: 'POST',
    data: params
  })
}

// 删除商品
export async function apiDelProduct(params) {
  return request( API_JAVA+'/jgw/jgwProduct/delete/' + params.id,{
    method: 'POST',
    data: params
  })
}
// 批量上架-批量下架-批量删除
export async function apiOperationProduct(params) {
  return request( API_JAVA+'/jgw/jgwProduct/operation',{
    method: 'POST',
    data: params,
    transformRequest: [function (data) {
      let ret = ''
      for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
// 个人中心-卖家-售后管理
export async function apiGetOrderAfterSales(params) {
  return request( API_JAVA+'/jgw/orderAfterSales/list',{
    method: 'GET',
    params: params
  })
}
// 查询订单-售后表明细
export async function apiGetOrderAfterSalesDetail(params) {
  return request( API_JAVA+'/jgw/orderAfterSales/' + params.id,{
    method: 'GET',
  })
}
// 个人中心-卖家-售后处理
export async function apiUpdateOrderAfterSales(params) {
  return request( API_JAVA+'/jgw/orderAfterSales/update',{
    method: 'POST',
    data: params
  })
}
// 个人中心-卖家-关闭
export async function apiCloseOrderAfterSales(params) {
  return request( API_JAVA+'/jgw/orderAfterSales/close/' + params.id,{
    method: 'GET',
  })
}
// 个人中心-卖家-完结
export async function apiFinishOrderAfterSales(params) {
  return request( API_JAVA+'/jgw/orderAfterSales/finish/' + params.id,{
    method: 'GET',
  })
}
// 个人中心-卖家-发票申请表列表
export async function apiGetOrderInvoice(params) {
  return request( API_JAVA+'/jgw/orderInvoiceRequests/auditList',{
    method: 'GET',
    params: params
  })
}
// 个人中心-卖家-开票审核
export async function apiUpdateOrderInvoice(params) {
  return request( API_JAVA+'/jgw/orderInvoiceRequests/update',{
    method: 'POST',
    data: params
  })
}
// 个人中心-卖家-发票申请表明细
export async function apiGetOrderInvoiceDetail(params) {
  return request( API_JAVA+'/jgw/orderInvoiceRequests/' + params.id,{
    method: 'GET',
  })
}
// 个人中心-卖家-新增订单合同
export async function apiAddOrderContract(params) {
  return request( API_JAVA+'/jgw/jgwOrderContract/add',{
    method: 'POST',
    data: params
  })
}
// 个人中心-卖家-根据合同id查询合同文件
export async function apiGetOrderContract(params) {
  return request( API_JAVA+'/jgw/jgwOrderContract/' + params.id,{
    method: 'GET',
  })
}
// 个人中心-卖家-根据条件查询订单评价列表
export async function apiGetEvaluateList(params) {
  return request( API_JAVA+'/jgw/Evaluate/list',{
    method: 'GET',
    params: params
  })
}
// 个人中心-卖家-删除订单评价
export async function apiDeleteEvaluate(params) {
  return request( API_JAVA+'/jgw/Evaluate/delete/' + params.id,{
    method: 'POST',
  })
}
// 个人中心-卖家-查询订单评价明细
export async function apiGetEvaluateDetail(params) {
  return request( API_JAVA+'/jgw/Evaluate/' + params.id,{
    method: 'GET',
  })
}
// 个人中心-卖家-根据条件查询物流公司列表
export async function apiGetLogisticsCompany(params) {
  return request( API_JAVA+'/jgw/logistics/listCompany',{
    method: 'GET',
    params: params
  })
}
// 个人中心-卖家-新增物流公司
export async function apiAddLogisticsCompany(params) {
  return request( API_JAVA+'/jgw/logistics/addCompany',{
    method: 'POST',
    data: params
  })
}
// 个人中心-卖家-更新物流公司
export async function apiUpdateLogisticsCompany(params) {
  return request( API_JAVA+'/jgw/logistics/updateCompany',{
    method: 'POST',
    data: params
  })
}
// 个人中心-卖家-删除物流公司
export async function apiDeleteLogisticsCompany(params) {
  return request( API_JAVA+'/jgw/logistics/deleteCompany/' + params.id,{
    method: 'POST',
  })
}
// 个人中心-卖家-根据条件查询物流列表
export async function apiGetLogisticsList(params) {
  return request( API_JAVA+'/jgw/logistics/list',{
    method: 'GET',
    params: params
  })
}
// 个人中心-卖家-新增物流
export async function apiAddLogistics(params) {
  return request( API_JAVA+'/jgw/logistics/add',{
    method: 'POST',
    data: params
  })
}
// 个人中心-卖家-更新物流
export async function apiUpdateLogistics(params) {
  return request( API_JAVA+'/jgw/logistics/update',{
    method: 'POST',
    data: params
  })
}
// 个人中心-卖家-删除物流
export async function apiDeleteLogistics(params) {
  return request( API_JAVA+'/jgw/logistics/delete/' + params.id,{
    method: 'POST',
  })
}
// 个人中心-卖家-查询物流明细
export async function apiGetLogisticsDetail(params) {
  return request( API_JAVA+'/jgw/logistics/' + params.id,{
    method: 'GET',
  })
}
// 个人中心-卖家-根据条件查询仓库列表
export async function apiGetWarehouseList(params) {
  return request( API_JAVA+'/jgw/warehouse/list',{
    method: 'GET',
    params: params
  })
}
// 个人中心-卖家-新增仓库
export async function apiAddWarehouse(params) {
  return request( API_JAVA+'/jgw/warehouse/add',{
    method: 'POST',
    data: params
  })
}
// 个人中心-卖家-更新仓库
export async function apiUpdateWarehouse(params) {
  return request( API_JAVA+'/jgw/warehouse/update',{
    method: 'POST',
    data: params
  })
}
// 个人中心-卖家-删除仓库
export async function apiDeleteWarehouse(params) {
  return request( API_JAVA+'/jgw/warehouse/delete/' + params.id,{
    method: 'POST',
  })
}
// 个人中心-卖家-查询订单评价明细
export async function apiGetWarehouseDetail(params) {
  return request( API_JAVA+'/jgw/warehouse/' + params.id,{
    method: 'GET',
  })
}
// 个人中心-卖家-根据条件查询调拨商品列表
export async function apiGetAllocateList(params) {
  return request( API_JAVA+'/jgw/allocate/list',{
    method: 'GET',
    params: params
  })
}
// 个人中心-卖家-新增调拨
export async function apiAddAllocate(params) {
  return request( API_JAVA+'/jgw/allocate/add',{
    method: 'POST',
    data: params
  })
}
// 个人中心-卖家-更新调拨
export async function apiUpdateAllocate(params) {
  return request( API_JAVA+'/jgw/allocate/update',{
    method: 'POST',
    data: params
  })
}
// 个人中心-卖家-删除调拨
export async function apiDeleteAllocate(params) {
  return request( API_JAVA+'/jgw/allocate/delete/' + params.id,{
    method: 'POST',
  })
}
// 个人中心-卖家-查询调拨明细
export async function apiGetAllocateDetail(params) {
  return request( API_JAVA+'/jgw/allocate/' + params.id,{
    method: 'GET',
  })
}
// 个人中心-卖家-根据条件查询调拨商品列表
export async function apiGetListGoodsList(params) {
  return request( API_JAVA+'/jgw/allocate/listGoods',{
    method: 'GET',
    params: params
  })
}
// 商家统计-数据统计-订单区域地图
export function getOrderMap(params) {
  return request( API_JAVA+'/jgw/jgwOrder/getOrderMap',{
    method: 'GET',
    params: params
  })
}
// 商家统计-数据统计-订单月度趋势图
export function getOrderMonrend(params) {
  return request( API_JAVA+'/jgw/jgwOrder/getOrderMonrend',{
    method: 'GET',
    params: params
  })
}
export function getProductSales(params) {
  return request( API_JAVA+'/jgw/jgwOrder/getproductSales',{
    method: 'GET',
    params: params
  })
}
// 商家统计-数据统计-汇总
export function summary(params) {
  return request( API_JAVA+'/jgw/jgwOrder/summary',{
    method: 'GET',
    params: params
  })
}
/**
 * 个人中心-卖家-订单-查询付款凭证
 */
export async function getJgwPaymentDetail(params) {
  return request(API_JAVA+ '/jgw/Payment/'+ params.orderId,{
    method: 'GET',
  })
}
// 个人中心-卖家-订单-新增支付信息
export async function apiAddReceipt(params) {
  return request( API_JAVA+'/jgw/Receipt/add',{
    method: 'POST',
    data: params
  })
}
// 个人中心-卖家-订单-更新支付信息
export async function apiUpdateReceipt(params) {
  return request( API_JAVA+'/jgw/Receipt/update',{
    method: 'POST',
    data: params
  })
}
// 个人中心-卖家-订单-删除支付信息
export async function apiDeleteReceipt(params) {
  return request( API_JAVA+'/jgw/Receipt/delete/' + params.id,{
    method: 'POST',
  })
}
// 个人中心-卖家-订单-查询支付信息明细
export async function apiGetReceiptDetail(params) {
  return request( API_JAVA+'/jgw/Receipt/' + params.id,{
    method: 'GET',
  })
}
// 个人中心-卖家-订单-新增发货信息
export async function apiAddSendOutGoods(params) {
  return request( API_JAVA+'/jgw/SendOutGoods/add',{
    method: 'POST',
    data: params
  })
}
// 个人中心-卖家-订单-更新发货信息
export async function apiUpdateSendOutGoods(params) {
  return request( API_JAVA+'/jgw/SendOutGoods/update',{
    method: 'POST',
    data: params
  })
}
// 个人中心-卖家-订单-删除发货信息
export async function apiDeleteSendOutGoods(params) {
  return request( API_JAVA+'/jgw/SendOutGoods/delete/' + params.id,{
    method: 'POST',
  })
}
// 个人中心-卖家-订单-查询发货信息明细
export async function apiGetSendOutGoodstDetail(params) {
  return request( API_JAVA+'/jgw/SendOutGoods/' + params.id,{
    method: 'GET',
  })
}
// 行情指数
export async function apiGetMarketIndex(params) {
  return request( API_JAVA+'/tmr/index/getMarketIndex',{
    method: 'GET',
    params: params
  })
}

// 品类
export async function apiCaregoryData(params) {
  return request( API_JAVA+'/purchase/category/index/linklist',{
    method: 'GET',
    params: params
  })
}

// 规格
export async function apiSpecificationData(params) {
  return request( API_JAVA+'/jgw/jgwProduct/mall/sku',{
    method: 'GET',
    params: params
  })
}

// 品牌
export async function apiBrandData(params) {
  return request( API_JAVA+'/jgw/jgwProductBrand/list',{
    method: 'GET',
    params: params
  })
}

// 品牌
export async function apiToBuy(params) {
  return request( API_JAVA+'/jgw/purchase/add',{
    method: 'POST',
    data: params
  })
}

// 新增实名认证
export async function apiPostRealName(params) {
  return request( API_JAVA+'/sys/RealnameAuthentication/add',{
    method: 'POST',
    data: params
  })
}

// 修改实名认证
export async function apiPostChangeRealName(params) {
  return request( API_JAVA+'/sys/RealnameAuthentication/update',{
    method: 'POST',
    data: params
  })
}

// 获取实名认证信息
export async function apiGetRealName(params) {
  return request( API_JAVA+'/sys/RealnameAuthentication/reception',{
    method: 'GET',
    params: params
  })
}

// 成交动态
export async function apiGetDealList(params) {
  return request(`${API_JAVA}/tmr/index/deal`, {
    method: 'GET',
    params
  })
}

// 求购动态
export async function apiGetBuyingList(params) {
  return request(`${API_JAVA}/tmr/index/ask/buy`, {
    method: 'GET',
    params
  })
}

// 布瑞克早报
export function apiGetMorningPaper(params) {
  return request(`${API_JAVA}/tmr/index/morning/paper`, {
    method: 'GET',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/hm.js